import { render, staticRenderFns } from "./OverlayTopLeftIcon.vue?vue&type=template&id=3ddb19fc&"
import script from "./OverlayTopLeftIcon.vue?vue&type=script&lang=js&"
export * from "./OverlayTopLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports